<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
  export default {
    name: 'App',

    mounted() {

      if (localStorage.getItem('settings') === null) {
        this.$router.push({name: 'settings'});
      }

    },
  };
</script>





<style  lang="scss">
    $animationDuration: 2s;
    @import "~vue2-animate/src/sass/vue2-animate.scss";

</style>

<style>
    @import '~bootstrap/dist/css/bootstrap.min.css';

    :root {
        --dark-orange: #F16521;
        --light-orange: #FBAF3F;
        --dark-green: #006738;
        --light-green: #009344;
        --dark-gray: #72706B;
        --background: #F5E8D9;
    }

    .row {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap;
        margin-right: 0 !important;
        margin-left: 0 !important;
    }

    .text-bold {
        font-weight: 700;
    }



    #standby {
        background-color: var(--light-orange);
    }


    .products-box {
        height: 1420px;
        overflow-y: scroll;
    }

    .products-box-cart {
        height: 1265px;
        overflow-y: scroll;
    }

    #footer .row {
        height: 182px;
        overflow-y: scroll;
    }

    .scrollbar {
        overflow-y: scroll;
        scrollbar-color: var(--dark-orange) var(--background);
    }

    .navbar {
        white-space: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }

    .navbar::-webkit-scrollbar {
        display: none;
    }

    .finished-box {
        margin-top: 30%;
        background-color: var(--light-orange)
    }

</style>
